/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import { VuetifyIcon } from 'vuetify/types/services/icons';
import LservIconInternal from './LservIconInternal.vue';

const icons: {[key: string]: VuetifyIcon} = {};

const lsIconNames = [
  'info_outlined',
  'info',
  'calendar_support_date',
  'issued',
  'description_small',
  'form',
  'wifi',
  'error_octagon_outline',
  'restore_small',
  'sign_out',
  'warning',
  'wifi_off',
  'open_in_new_window',
  'calendar_30',
  'calendar_date',
  'calendar_empty',
  'add',
  'arrow_back',
  'arrow_down',
  'arrow_left',
  'arrow_next',
  'arrow_right',
  'arrow_up',
  'attachment_view',
  'block_smaller',
  'block',
  'business_small',
  'business',
  'cancel_outline',
  'cancel',
  'caret',
  'check_circle',
  'check_small',
  'check_smaller',
  'check',
  'chevron_small',
  'close_small',
  'close',
  'code',
  'comment',
  'delete_small',
  'delete',
  'download',
  'edit_small',
  'edit',
  'error_octagon',
  'error_outline',
  'error',
  'exit',
  'expiration_date_expired',
  'expiration_date_extend',
  'expiration_date_near',
  'expiration_date',
  'extend',
  'filter',
  'help_outline',
  'license_academic',
  'license_commercial',
  'license_company_source_code',
  'license_company_wide',
  'license_demo',
  'license_developer_source_code',
  'license_developer',
  'license_open_source',
  'license_personal',
  'license_project_source_code',
  'license_project',
  'link',
  'list_view',
  'mail_outline_small',
  'mail_outline',
  'mail',
  'menu',
  'more_vert',
  'notifications',
  'person',
  'phone',
  'product_dotnetbrowser',
  'product_jexel',
  'product_jniwrapper',
  'product_jxbrowser',
  're_verification',
  'restore',
  'search_small',
  'search',
  'settings',
  'smartphone',
  'speedometer',
  'textarea',
  'time',
  'to_request'
];

lsIconNames.forEach(iconName => {
  icons[iconName] = {
    component: LservIconInternal,
    props: {
      iconId: 'icon-' + iconName
    }
  }
});

export default icons;
